module.exports = __webpack_public_path__ + "img/field2.8ea43b27.png";